import OtaClient from '@crowdin/ota-client'
import i18n, { type ModuleType } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import resourcesToBackend from 'i18next-resources-to-backend'

import { initReactI18next } from 'react-i18next'

class CrowdinOtaI18next {
  type: ModuleType
  otaClient: OtaClient

  constructor(hash: string) {
    this.type = 'backend'
    this.otaClient = new OtaClient(hash)
  }

  read(
    language: string,
    _namespace: string,
    callback: (error: Error | null, data?: unknown) => void
  ) {
    this.otaClient.getTranslations().then(translations => {
      console.log('Fetched translations:', JSON.stringify(translations[language]))
    })
    this.otaClient.getContent().then(content => {
      console.log('Fetched content:', JSON.stringify(content[language]))
    })
    this.otaClient.getStrings().then(strings => {
      console.log('Fetched strings:', JSON.stringify(strings[language]))
    })
    this.otaClient
      .getStringsByLocale(language)
      .then(value => {
        console.log('Fetched translations:', JSON.stringify(value))
        callback(null, value)
      })
      .catch(e => {
        console.error('Error fetching translations:', e)
        callback(e, null)
      })
  }
}

const crowdinKey = import.meta.env.VITE_CROWDIN_KEY

if (!crowdinKey) {
  i18n.use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`@/locales/${language}/${namespace}.json`)
    )
  )
} else {
  const module = new CrowdinOtaI18next(crowdinKey)

  i18n.use(module)
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    ns: [
      '_global',
      '_routes',
      '@feature_fleet',
      '@feature_mission',
      '@feature_charging',
      '@feature_routing',
      '@feature_user',
      '@feature_vehicle',
      '@feature_reporting',
      '@feature_administration',
      '@feature_marketplace',
      '@feature_notification'
    ],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
